<template>
  <span>
    <span v-if="!isFontAwesomeIcon" :class="cssClass" :id="`${section}-tooltip-description-${index}`">
      <i :class="['fas', 'fa-question-circle', 'variant-' + variant]"></i>
    </span>
    <font-awesome-icon
      v-else
      :class="cssClass"
      :icon="fontAwesomeIcon"
      :id="`${section}-tooltip-description-${index}`"
    ></font-awesome-icon>
    <b-tooltip :target="`${section}-tooltip-description-${index}`" :triggers="triggers">
      <span v-html="tooltipText"></span>
    </b-tooltip>
  </span>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: 0,
    },
    isFontAwesomeIcon: {
      type: Boolean,
      default: false,
    },
    fontAwesomeIcon: {
      type: String,
      default: '',
    },
    cssClass: {
      type: Array,
      default: () => [],
    },
    section: {
      type: String,
      required: true,
    },
    tooltipText: {
      type: String,
      required: true,
    },
    triggers: {
      type: String,
      default: 'hover',
    },
    variant: {
      type: String,
      default: 'orange',
    },
  },
}
</script>

<style lang="scss" scoped>
.variant-black {
  color: #000;
}
.variant-orange {
  color: var(--primary);
}
</style>
